export const BGN_TO_EUR_RATE = 1.95583;
export const CURRENCY_SYMBOL = "€";

export function formatCurrency(value) {
  const number = Number(value) || 0;
  return `${number.toFixed(2)} ${CURRENCY_SYMBOL}`;
}
